// extracted by mini-css-extract-plugin
module.exports = {"song":"PlaylistSong_song__4whjR","song__title":"PlaylistSong_song__title__uP7Z3","song__time":"PlaylistSong_song__time__3jPmD"};